define('plugin/package/view/PackageItemView',['require','plugin/package/view/PackageIntemBaseView','view/helper/DatePicker','lib/theme/ThemeSettings','Config'],function (require) {

    var Parent = require('plugin/package/view/PackageIntemBaseView');
    var DatePicker = require('view/helper/DatePicker');
    var ThemeSettings = require('lib/theme/ThemeSettings');
    var Config = require('Config');

    /**
     * Package item view
     *
     * @class PackageItemView
     */
    return Parent.extend({

        getTemplate: function () {
            if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
                return '#package_item_view_list';
            }
            return '#package_item_view';
        },
        ui: {
            'startDateInput': '.sb_start_date'
        },
        events: {
            'change @ui.startDateInput': 'setStartDate'
        },
        _startDateValue: null,
        _datepicker: null,

        initialize: function () {
            var today = Config.getInstance().getServerDate();
            this._startDateValue = today.getMysqlDate(); 

            Parent.prototype.initialize.apply(this, arguments);
        },

        setStartDate: function (event, b) {
            if (this._datepicker) {
                this._datepicker.datepicker('destroy');
                this._datepicker = null;

                this._startDateValue = this.ui.startDateInput.val();
                this.render();
            }
        },

        onRender: function () {
            var today = Config.getInstance().getServerDate();
            this._datepicker = DatePicker.initDatepicker(this.ui.startDateInput, {
                'startDate': today
            });
        },

        serializeData: function () {
            var data = Parent.prototype.serializeData.apply(this);
            data.start_date = this._startDateValue;

            return data;
        }

    });

});
